var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snackbar"},[_c('div',{staticClass:"d-flex align-center justify-space-around"},[_c('p',[_vm._t("default")],2),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"typing-indicator"},[_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }